module.exports = __webpack_public_path__ + "img/46.dd59ea66.jpg";